import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Grid, Typography, Container } from '@mui/material';
import backgImg from "../../../assets/images/backg.jpg";
import heroImg from "../../../assets/images/hero.png";

const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        py: { xs: 0, md: 0 },  // Remove top/bottom padding to bring the section to the top
        width: '100%',
        backgroundImage: `url(${backgImg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        overflow: 'hidden',
        mt: '0%',  // Moves the whole component up by 10%
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          {/* Text Section */}
          <Grid item xs={12} md={6}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 700,
                fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                color: '#1a1a1a',
                textAlign: { xs: 'center', md: 'left' },
                fontFamily: `'Segoe UI', Roboto, sans-serif`,
              }}
            >
              {t('homepage.hero_title')}
            </Typography>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 500,
                fontSize: { xs: '1rem', sm: '1.2rem' },
                color: 'text.secondary',
                mt: 2,
                textAlign: { xs: 'center', md: 'left' },
                fontFamily: `'Segoe UI', Roboto, sans-serif`,
              }}
            >
              {t('homepage.hero_subtitle')}
            </Typography>
          </Grid>

          {/* Image Section */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Box
                component="img"
                src={heroImg}
                alt="Hero"
                sx={{
                  width: '100%',
                  maxWidth: 500,
                  borderRadius: 2,
                  mt: { xs: 4, md: 0 },
                  transition: 'transform 0.5s ease-in-out, opacity 0.5s ease-in-out',
                  opacity: 0.9,
                  '&:hover': {
                    transform: 'scale(1.03)',
                    opacity: 1,
                  },
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default HeroSection;
